import { useState } from 'react'
import s from './Checklist.scss'
import { InputContainer, Checkbox } from 'components/ideal-core-ui'
import { Button, Progress } from 'reactstrap'
import cn from 'classnames'
import { timezoneDate } from 'utils/helpers'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'

const Checklist = ({
  checklist,
  toggleItem,
  addItem,
  deleteItem,
  deleteChecklist,
  setEditedChecklist,
  setEditedItem,
  contactId
}) => {
  const [itemName, setItemName] = useState('')
  const value = checklist.items.filter(item => item.status === 'Complete').length

  return (
    <div className={s.checklist} key={checklist.id}>
      <h6>
        {checklist.title}
        <FaPencilAlt
          className={s.removeChecklist}
          onClick={() => setEditedChecklist({ ...checklist, contactId })}
        />
        <FaTrashAlt
          className={s.removeChecklist}
          onClick={() => deleteChecklist(checklist.id, contactId)}
        />
      </h6>
      {checklist.items.length > 0 && (
        <Progress value={value} className={s.progress} max={checklist.items.length}>
          {((value / checklist.items.length) * 100).toFixed()}%
        </Progress>
      )}
      <div className={s.itemsWrapper}>
        {checklist.items.length ? (
          checklist.items.map(item => (
            <div className={s.itemWrapper} key={item.id}>
              <div className={s.item}>
                <Checkbox
                  size="md"
                  isChecked={item.status === 'Complete'}
                  triggerCheckbox={value =>
                    toggleItem(item.id, value.target.checked, checklist.id, contactId)
                  }
                />
                <span
                  className={cn(s.itemName, {
                    [s.completed]: item.status === 'Complete'
                  })}
                >
                  {item.name}
                </span>
                <FaPencilAlt
                  className={s.editItem}
                  onClick={() => setEditedItem({ item, checklistId: checklist.id, contactId })}
                />
                <FaTrashAlt
                  className={s.removeItem}
                  onClick={() => deleteItem(checklist.id, item.id, contactId)}
                />
              </div>
              {item.status === 'Complete' && (
                <div className={s.itemDetails}>
                  Completed by {item.modifiedBy} on {timezoneDate(item.modifiedAt)}
                </div>
              )}
            </div>
          ))
        ) : (
          <div>
            <i>This checklist has no items</i>
          </div>
        )}
        <InputContainer
          type="text"
          text={itemName || ''}
          placeholder="Add Item"
          cb={value => setItemName(value)}
          classname={s.addItemInput}
        />
        <Button
          className={s.greenBtn}
          onClick={() => {
            addItem(checklist.id, itemName, contactId)
            setItemName('')
          }}
        >
          Add
        </Button>
      </div>
    </div>
  )
}

export default Checklist
